import { render, staticRenderFns } from "./editBtn.vue?vue&type=template&id=54cd01b5&scoped=true"
import script from "./editBtn.vue?vue&type=script&lang=js"
export * from "./editBtn.vue?vue&type=script&lang=js"
import style0 from "./editBtn.vue?vue&type=style&index=0&id=54cd01b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cd01b5",
  null
  
)

export default component.exports